/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 *
	 */

	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */

	Tc.Module.Glossary = Tc.Module.extend({

		PAGESIZE: 20,

		init: function($ctx, sandbox, modId) {
			this.$ctx = $ctx;
			this.loadingIndicator = $('.modLoadingIndicator', this.$ctx);
			this.lastLetter = '';
			this.hasMoreResults = true;
			this.itemsLoaded = 0;
			this.groupByFirstLetter = this.$ctx.data('group-by-first-letter');
			this.items = $('.data-provider-item', this.$ctx);
			this.itemsContainer = this.items.parent();
			this.isMobile = $('body').hasClass('is-mobile');
			this._super($ctx, sandbox, modId);
		},

		on: function(callback) {
			this.items.detach();
			this.loadingIndicator.on('visible', $.proxy(this.eventEndOfListReached, this));
			this.$ctx.addClass('initialized');
			callback();
		},

		eventEndOfListReached: function() {
			if (!this.isLoading && this.hasMoreResults) {
				this.isLoading = true;
				this.loadMoreResults();
			}
		},

		loadMoreResults: function() {
			var mod = this,
				item, i, letter;
			for (i = 0; i < mod.PAGESIZE && mod.itemsLoaded < mod.items.length; i++, mod.itemsLoaded++) {
				item = $(mod.items.get(mod.itemsLoaded));
				letter = mod.getLetter(item);
				// if there is no letter, the meta data title is not set on the referred page.
				// hence skip this item.
				if(!letter) {
					continue;
				}

				if (letter !== mod.lastLetter && mod.groupByFirstLetter) {
					mod.lastLetter = letter;
					mod.itemsContainer.append($('<h2>').addClass('letter').text(mod.lastLetter));
				}
				if (mod.isMobile) {
					mod.bindMobileClickHandler(item);
				}
				mod.itemsContainer.append(item);
			}
			if (mod.itemsLoaded === mod.items.length) {
				this.hasMoreResults = false;
				this.loadingIndicator.trigger('stop');
				this.$ctx.addClass('loaded');
			}
			this.isLoading = false;
		},

		getLetter: function(item) {
			var title = item.find('h2, h3').text();
			if (title.length > 0) {
				return title[0].toUpperCase();
			}
			return null;
		},

		bindMobileClickHandler: function(item) {
			var mod = this,
				links = item.find('h2 a, h3 a');
			links = links.length > 0 ? links : item.find('a');
			if (links.length > 0) {
				item.on('click', function(event){
					if (!$(event.target).is('a')) {
						links[0].click();
					}
				});
			} else {
				item.addClass('no-link');
			}
		}
	});
	
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Glossary.js
// module id = 142
// module chunks = 0